<div class="container">
  <div class="row conteneur-simuAL-cnaf">
    <div class="col-sm-12 center-middle-block">
        <router-outlet></router-outlet>
    </div>
  </div>
</div>